import {
  Autocomplete,
  Box,
  Button,
  Card,
  Grid,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import RightViewLayout from "../../components/RighViewLayout";
import { REACT_PRODUCT } from "../../router/ReactEndPoints";
import CustomInput from "../../components/CustomInput";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { attributeList, createProduct } from "../../services/ProductService";
import { useSnackbar } from "notistack";
import CommonUtil from "../../util/CommonUtils";
import axios from "axios";
import DropzoneComponent from "../../components/layout-components/DropzoneComponent";
import { ReactComponent as Upload_Image } from "../../assets/images/Upload_Image.svg";
import { uploadFile } from "@/services/Upload";
export default function AddProduct() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [productImage, setProductImage] = useState();
  const [payload, setPayload] = useState({
    productImage: "",
  });

  const [newLabels, setNewLabels] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [customePayload, setCustomePayload] = useState({});

  useEffect(() => {
    attributeList().then((res) => {
      if (res?.data?.code == "LVLI0000") {
        let list = res?.data?.data?.filter((item) => {
          return !(
            item.dataLevel === "System Default" && item.name === "priceRule"
          );
        });

        setNewLabels(
          list?.filter(
            (item) =>
              item.type === "1" ||
              item.type == null ||
              item.type === "" ||
              item.type === undefined
          )
        );
        setFileList(list?.filter((item) => item.type == "2"));
      }
    });
  }, []);

  useEffect(() => {
    const payloadObject = {};
    newLabels.forEach((label) => {
      delete payloadObject[label.name];
      payloadObject[label.name] = "";
    });

    setCustomePayload(payloadObject);
  }, [newLabels]);

  const handleCustomChange = (name, value) => {
    setCustomePayload((prevPayload) => ({
      ...prevPayload,
      [name]: value,
    }));
  };

  const [imageMap, setImageMap] = useState({});

  const handleImage = (name, file) => {
    const maxSize = 3 * 1024 * 1024; // 3MB in bytes
    if (
      file.file.type === "image/png" ||
      file.file.type === "image/jpeg" ||
      file.file.type === "image/bmp"
    ) {
      let fileSize = file.file.size;
      let size = parseInt(fileSize);
      if (size <= maxSize) {
        uploadFile(file).then((res) => {
          if (name == "productImage") {
            setPayload((prevPayload) => {
              const newPayload = { ...prevPayload };
              newPayload[name] = res?.data?.data;
              return newPayload;
            });
          } else {
            setCustomePayload((prevPayload) => {
              const newPayload = { ...prevPayload };
              delete newPayload["productImage"];
              newPayload[name] = res?.data?.data;
              return newPayload;
            });
          }
        });
        setImageMap((prev) => ({ ...prev, [name]: file?.base64 }));
      } else {
        enqueueSnackbar(t("tips_product.file_size_limit"), {
          variant: "error",
        });
      }
    } else {
      enqueueSnackbar(t("EPLPR0304"), {
        variant: "error",
      });
    }
  };

  const uploadProductPhoto = (data) => {
    var bodyFormData = new FormData();
    bodyFormData.append("url", data?.data?.data?.preSignedUrl);
    bodyFormData.append("file", productImage);

    axios({
      method: "post",
      url: process.env.REACT_APP_SERVER_URL + "/web/product/image",
      data: bodyFormData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.getItem("USER_TOKEN"),
      },
    }).then(() => {
      enqueueSnackbar(t("product.add_success"), { variant: "success" });
      navigate(REACT_PRODUCT);
    });
  };

  const handleSubmit = () => {
    let request = {
      product: payload,
      object: customePayload,
    };

    createProduct(request).then((res) => {
      if (res?.data?.code == "LVLI0008") {
        if (CommonUtil.isEmpty(res.data?.data?.preSignedUrl) && !productImage) {
          enqueueSnackbar(t("product.add_success"), { variant: "success" });
          navigate(REACT_PRODUCT);
        } else {
          uploadProductPhoto(res);
        }
      } else {
        enqueueSnackbar(res?.data?.message, { variant: "error" });
      }
    });
  };

  return (
    <RightViewLayout
      title={t("product.add_product")}
      navigateBack={REACT_PRODUCT}
    >
      <Grid sx={{ height: "100%" }}>
        <Card elevation={0} sx={{ height: "100%" }}>
          <Grid container item mt={3}>
            <Grid
              container
              px={2}
              spacing={2}
              sx={{ maxHeight: 450, overflowY: "auto" }}
            >
              <Grid item xs={12} md={4}>
                <Typography
                  style={{
                    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                    fontWeight: 400,
                    fontSize: "12px",
                    color: "rgb(71, 75, 79)",
                  }}
                  color="textSecondary"
                  pt={1}
                >
                  {t("product.product_picture")}
                </Typography>
                <DropzoneComponent
                  getExcelFile={(excelData) =>
                    handleImage("productImage", excelData)
                  }
                >
                  <Box
                    mt={0}
                    p={1}
                    sx={{
                      border: "2px dashed #36C96D",
                      borderRadius: "5px",
                      backgroundColor: "rgba(54, 201, 109,0.1)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      height: "400px",
                    }}
                  >
                    {imageMap["productImage"] ? (
                      <img
                        src={imageMap["productImage"]}
                        alt="Uploaded"
                        style={{ maxWidth: "100%", maxHeight: "200px" }}
                      />
                    ) : (
                      <div style={{ textAlign: "center" }}>
                        <Upload_Image />
                        <Typography
                          sx={{
                            fontSize: "14px",
                            textAlign: "center",
                            opacity: "0.8",
                            mt: 1,
                          }}
                        >
                          {t("tips_product.drag_and_drop_file")}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            textAlign: "center",
                            opacity: "0.8",
                          }}
                        >
                          {t("tips_product.upload_image_format")}
                        </Typography>
                      </div>
                    )}
                  </Box>
                </DropzoneComponent>
              </Grid>

              <Grid container xs={12} md={8} item spacing={2}>
                {newLabels.map((field, index) => (
                  <Grid key={index} item md={4} xs={12}>
                    <CustomInput
                      id="AddProduct12"
                      size="small"
                      label={field.label}
                      value={customePayload[field.name]}
                      handleChange={(event) =>
                        handleCustomChange(field.name, event.target.value)
                      }
                      required={field.name == "productName"}
                      name={field.name}
                      inputProps={{
                        maxLength: 50,
                      }}
                      resetError={() => console.log()}
                      fullWidth
                      placeholder={t("common.enter") + field.label}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>

            {/* Additional Images Section */}
            {fileList && fileList.length > 0 && (
              <Grid container px={2} mt={2} spacing={3}>
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    {fileList?.map((item, index) => {
                      return (
                        <Grid item xs={12} sm={6} md={3} key={index}>
                          <Typography
                            style={{
                              fontFamily:
                                "Roboto, Helvetica, Arial, sans-serif",
                              fontWeight: 400,
                              fontSize: "12px",
                              color: "rgb(71, 75, 79)",
                            }}
                            color="textSecondary"
                            pt={1}
                          >
                            {item?.label}
                          </Typography>
                          <DropzoneComponent
                            getExcelFile={(excelData) =>
                              handleImage(item.name, excelData)
                            }
                          >
                            <Box
                              mt={0}
                              p={1}
                              sx={{
                                border: "2px dashed #36C96D",
                                borderRadius: "5px",
                                backgroundColor: "rgba(54, 201, 109,0.1)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                height: "200px",
                              }}
                            >
                              {imageMap[item.name] ? (
                                <img
                                  src={imageMap[item.name]}
                                  alt="Uploaded"
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "100px",
                                  }}
                                />
                              ) : (
                                <div style={{ textAlign: "center" }}>
                                  <Upload_Image />
                                  <Typography
                                    sx={{
                                      fontSize: "12px",
                                      textAlign: "center",
                                      opacity: "0.8",
                                      mt: 1,
                                    }}
                                  >
                                    {t("tips_product.drag_and_drop_file")}
                                  </Typography>
                                </div>
                              )}
                            </Box>
                          </DropzoneComponent>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Grid>
              </Grid>
            )}

            {/* Action Buttons */}
            <Grid container spacing={2} px={2} py={3}>
              <Grid item xs={12}>
                <Box display={"flex"} justifyContent={"flex-end"}>
                  <Box item pr={2}>
                    <Button
                      id="AddProduct-button-02"
                      className="text-transform-none"
                      variant="outlined"
                      onClick={() => navigate(REACT_PRODUCT)}
                      size="large"
                    >
                      {t("common.back")}
                    </Button>
                  </Box>
                  <Box item>
                    <Button
                      id="AddProduct-button-01"
                      variant="contained"
                      size="large"
                      className="text-transform-none"
                      onClick={handleSubmit}
                      style={{
                        size: "medium",
                        borderRadius: "8px",
                        opacity: 1,
                        background:
                          "transparent linear-gradient(270deg, #1487CA 0%, #78BC27 100%) 0% 0% no-repeat padding-box",
                      }}
                    >
                      {t("common.save")}
                    </Button>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </RightViewLayout>
  );
}
